import React from 'react';
import Autosuggest from 'react-autosuggest';
import { ROOT_URL } from '../../actions/root_url';
import axios from 'axios';
import { Row, Col } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import IsolatedScroll from 'react-isolated-scroll';

const fetchProductDetail = (customerId, searchType, value, success, failed) => {
  const url = `${ROOT_URL}v1/inventory/sales_order/search/simplified/${customerId}/?${searchType}=${value}`;
  if (!customerId) {
    failed();
    return;
  }
  console.log('fetchProductDetail', url);
  axios({
    method: "GET",
    url,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
  })
    .then(res => {
      success(res.data);
    })
    .catch(err => {
      console.log('err', err);
    })
}
// Imagine you have a list of languages that you'd like to autosuggest.
const languages = [
  {
    name: 'C',
    year: 1972
  },
  {
    name: 'Elm',
    year: 2012
  },
];

// Teach Autosuggest how to calculate suggestions for any given input value.
const getSuggestions = value => {
  const inputValue = value.trim().toLowerCase();
  const inputLength = inputValue.length;

  return inputLength === 0 ? [] : languages.filter(lang =>
    lang.name.toLowerCase().slice(0, inputLength) === inputValue
  );
};

// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
// const getSuggestionValue = suggestion => {
//   console.log('getSuggestionValue', suggestion);
//   return suggestion.name
// };

// Use your imagination to render suggestions.
const renderSuggestion = suggestion => (
  <Row
    className="suggestion"
    id="suggestion-render"
    className="sales-auto-suggest-suggestions"
    style={{ fontSize: '15px' }} // style={isHMM ? { fontSize: '13px' } : {}}
  >
    <Col xs={3}>
      {suggestion.Name}
    </Col>
    <Col xs={3}>
      {suggestion.Description}
    </Col>
    <Col xs={3}>
      {suggestion.ProductNum}
    </Col>
    <Col xs={3}>
      {suggestion.InStock}
    </Col>
  </Row>
);

class RMAAutoSuggest extends React.Component {
  constructor() {
    super();

    // Autosuggest is a controlled component.
    // This means that you need to provide an input value
    // and an onChange handler that updates this value (see below).
    // Suggestions also need to be provided to the Autosuggest,
    // and they are initially empty because the Autosuggest is closed.
    this.state = {
      value: '',
      suggestions: []
    };
  }

  onChange = (event, { newValue }) => {
    this.setState({
      value: newValue
    });
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  shapeData = (data) => {
    return data.splice(0, 5);
  }
  onSuggestionsFetchRequested = ({ value }) => {
    const {
      customerId,
      searchType = 'ProductNum',
    } = this.props;
    const success = (data) => {
      this.setState({
        suggestions: this.shapeData(data),
      });
    }
    const failed = (res) => {
      this.setState({
        suggestions: [],
      });
    }
    fetchProductDetail(customerId, searchType, value, success, failed)
  };

  onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
    event.stopPropagation();
    event.preventDefault();
    this.props.handleProductSelect(suggestion);
  }

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  renderSuggestionsContainer = ({ containerProps, children }) => {
    const { ref, ...restContainerProps } = containerProps;
    const callRef = scrollingDiv => {
      if (scrollingDiv !== null) {
        ref(scrollingDiv.component);
      }
    };

    return (
      <div {...restContainerProps} style={{ maxWidth: '100%' }}>
        <div className="container" style={{ width: '100%' }}>
          <Row style={{ padding: '10px 5px', margin: '0px' }} className="sales-auto-suggest-suggestions" id="sales-auto-suggest-header">
            <Col xs={3}>
              <Translate value="name" />
            </Col>
            <Col xs={3}>
              <Translate value="prod_desc" />
            </Col>
            <Col xs={3}>
              <Translate value="product_no" />
            </Col>
            <Col xs={3}>
              <Translate value="instock" />
            </Col>
          </Row>
        </div>
        <IsolatedScroll id="suggestions-customer-container" ref={callRef}>
          {children}
        </IsolatedScroll>
      </div>
    );
  }


  getSuggestionValue = (suggestion) => {
    // console.log('getSuggestionValue', suggestion);
    // return `${suggestion.Name} | ${suggestion.Description}`;
    return ''
  }

  render() {
    const { value, suggestions } = this.state;
    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder: 'search',
      value,
      onChange: this.onChange
    };

    // Finally, render it!
    return (
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        renderSuggestionsContainer={this.renderSuggestionsContainer}
        getSuggestionValue={this.getSuggestionValue}
        onSuggestionSelected={this.onSuggestionSelected}
        renderSuggestion={renderSuggestion}
        inputProps={inputProps}
      />
    );
  }
}

export default RMAAutoSuggest;


// WEBPACK FOOTER //
// ./master/jsx/components/RMA/RMAAutoSuggest.jsx